import axios from '../utils/axios';

export default function addCourse(adminId,data) { 
    return (
        axios.post('/admin/' + adminId +'/courses/course',  data )
    )
}